import { render, staticRenderFns } from "./t_href.vue?vue&type=template&id=60ba99d0&"
import script from "./t_href.vue?vue&type=script&lang=js&"
export * from "./t_href.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports